import styled from '@emotion/styled';
import XLine from '@icons/XLine';
import { pressActionEffect } from '@styles/mixin';

interface Props {
    onClose: () => void;
}

function CloseHeader({ onClose }: Props) {
    return (
        <Container>
            <CloseButton type='button'
                aria-label='close'
                onClick={onClose}>
                <XLine size={24} color='var(--color-text-secondary)'/>
            </CloseButton>
        </Container>
    );
}

const Container = styled.div`
    align-items: center;
    display: flex;
    height: 64px;
    justify-content: flex-end;
    padding: 0 var(--spacing-4);
`;

const CloseButton = styled.button`
    background: none;
    display: flex;
    padding: 0;
    ${pressActionEffect}
`;

export default CloseHeader;
